import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';
import fetchModel from 'epics/model/fetcher';

import type {
    FetchRequestListAction,
    FetchRequestListSuccess,
    FetchRequestListFailure,
} from 'state/actions/request-list';
import { FETCH_REQUEST_LIST_MODEL, fetchRequestListSuccess, fetchRequestListFailure } from 'state/actions/request-list';

import type { ErrorResponse } from 'epics/model/types';
import type { RequestListResponse } from 'rest/request-list';

export const requestListEpic: Epic<FetchRequestListAction, FetchRequestListSuccess | FetchRequestListFailure> = (
    action$
) => {
    return action$.ofType(FETCH_REQUEST_LIST_MODEL).switchMap((action) => {
        return fetchModel(action.payload)
            .filter(
                (response) =>
                    response.allReqFilter !== undefined &&
                    'requestList' in response.allReqFilter &&
                    Array.isArray(response.allReqFilter.requestList)
            )
            .flatMap((response) => {
                const filter = action.payload.params.filter;
                // TypeScript's Observable.filter() does not narrow types, so response.allReqFilter
                // is still typed as RequestListResponse | undefined here even though the preceding
                // .filter() guarantees it is defined and has a valid requestList array.
                const requestListModel = response.allReqFilter as RequestListResponse;
                return Observable.of(fetchRequestListSuccess({ ...requestListModel, filter }));
            })
            .catch((error: ErrorResponse) => {
                return Observable.of(fetchRequestListFailure(error));
            });
    });
};
